/* eslint-disable react-refresh/only-export-components -- This file exports a
   route MANIFEST, not components. Its screen is defined inside a factory so it
   can close over the API client, which puts it beyond Fast Refresh's reach
   whatever this file exports. */

/**
 * What the file library contributes to the route tree.
 *
 * `files.file.read` to reach it. Uploading and deleting need
 * `files.file.create` and `files.file.delete`, which the server enforces —
 * somebody who may only read gets the list and a refusal if they force an
 * upload, which is the correct pair of behaviours.
 */

import type { ApiClient } from "@hardauto/core-api";
import type { FeatureRoutes } from "@hardauto/core-router";

import { FilesScreen } from "./screens/FilesScreen";
import "./i18n";

export const FILES_PATHS = {
  library: "/files",
} as const;

export function filesRoutes(client: ApiClient, maxUploadBytes?: number): FeatureRoutes {
  function Files() {
    return <FilesScreen client={client} maxUploadBytes={maxUploadBytes} />;
  }

  return {
    id: "files",
    routes: [
      {
        path: FILES_PATHS.library,
        component: Files,
        layout: "app",
        requirement: { authenticated: true, permissions: ["files.file.read"] },
        nav: { labelKey: "files:nav.files", section: "main", order: 20 },
      },
    ],
  };
}
